import { DnvMapState, LayerState, MapViewState, DnvStoreWrapper } from 'dnv-lib';
import { Action } from '@ngrx/store';
import {
  AppMapViewLoadFinished
} from '../state-management/application/application.action';

export class AppStoreWrapper implements DnvStoreWrapper {
  GetMapViewState(store: any): MapViewState { return store.mapViewState; }
  GetDnvMapState(store: any): DnvMapState { return store.mapState; }
  GetLayerState(store: any): LayerState { return store.layerState; }
  GetFinishedLoadCallbackAction(payload: Action[]): Action { return new AppMapViewLoadFinished(payload); }
}
